"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strings = void 0;
var react_localization_1 = require("react-localization");
var english = {
    Label_Active: "Active",
    Label_FurtherOptions: "Further Options",
    Label_InfoMessage: "Information Message",
    Label_Loading: "Loading...",
    Label_MoreOptions: "More Options",
    Label_Saved: "Saved",
    Action_Close: "Close",
    Action_ClosePopup: "Close Popup",
    Action_Delete: "Delete",
    Action_Duplicate: "Duplicate",
    Action_DuplicateByCriteria: "Duplicate By Criteria",
    Action_DuplicateByField: "Duplicate By Field",
    Action_EditCriteria: "Edit Criteria",
    Action_Rename: "Rename",
    TextArea_Label_CurrentCount: "currently {0} characters of {1}",
    TextArea_Messages_MaximumCharacters: "Maximum characters reached",
    DatePicker_Label_DateInput: "Date Picker",
    DatePicker_Label_TimeInput: "Time Input",
    DatePicker_Label_Today: "Today",
    DateRange_Label_EndDateLabelDefault: "End Date",
    DateRange_Label_StartDateLabelDefault: "Start Date",
    DropList_Action_Confirm: "Confirm",
    DropList_Action_Reset: "Reset to default",
    DropList_Label_Select: "Select Row",
    FieldSelector_Action_AddToFavs: "Add to favourites",
    FieldSelector_Action_DeleteLinkTableButton: "Delete linked Table",
    FieldSelector_Action_LinkTableButton: "Select Child Table",
    FieldSelector_Action_RemoveFromFavs: "Remove from favourites",
    FieldSelector_Label_AvailableFields: "Available Fields",
    FieldSelector_Label_MainTable: "Main Table",
    FieldSelector_Label_MyFavourites: "My Favourites",
    FieldSelector_Label_SearchFieldList: "Search Field List",
    FieldSelector_Message_ClearThisSearch: "Clear this search",
    FieldSelector_Message_InsertFunction: "Insert function based on this field",
    FieldSelector_Message_SearchForFields: "Search for fields",
    FieldViewer_Label_EditFunction: "Edit Function",
    Treeview_Message_NoData: "No Data",
    UnsavedChangesPopup_Action_DontSave: "Don't Save",
    UnsavedChangesPopup_Action_KeepEditing: "Keep Editing",
    UnsavedChangesPopup_Action_Save: "Save",
    UnsavedChangesPopup_Label_Header: "Save Changes?",
    DeleteConfirmationPopup_Action_Cancel: "Cancel",
    DeleteConfirmationPopup_Action_Delete: "Delete",
    DeleteConfirmationPopup_Label_Header: "Confirm Deletion",
    FrameworkMessagesPopup_Action_Cancel: "Cancel",
    FrameworkMessagesPopup_Action_Fix: "Fix",
    FrameworkMessagesPopup_Action_Ignore: "Ignore",
    FrameworkMessagesPopup_Action_Ok: "OK",
    FrameworkMessagesPopup_Action_Undo: "Undo",
    FrameworkMessagesPopup_Message_InstructionsDetail: "Before we can complete that action, the following needs your attention:",
    FrameworkMessagesPopup_Message_InstructionsTitle: "Please review before we complete this task",
    FrameworkMessagesPopup_Message_ValidationErrors: "One or more messages have not been resolved",
    ToggleSwitch_Label_Disabled: "Toggle Switch Button is currently Off",
    ToggleSwitch_Label_Enabled: "Toggle Switch Button is currently On",
    ToggleSwitch_Label_Off: "Off",
    ToggleSwitch_Label_On: "On",
    WidgetDataCard_Action_Collapse: "Collapse Widget",
    WidgetDataCard_Action_Delete: "Delete Widget",
    WidgetDataCard_Action_Down: "Move Widget Down",
    WidgetDataCard_Action_Expand: "Expand Widget",
    WidgetDataCard_Action_Up: "Move Widget Up",
    Form_Message_RequiredKey: "Indicates required fields",
    Paginator_Action_MoveFirst: "Move First",
    Paginator_Action_MoveLast: "Move Last",
    Paginator_Action_MoveNext: "Move Next",
    Paginator_Action_MovePrevious: "Move Previous",
    Paginator_Label_CurrentPage: "Current Page",
    Paginator_Label_Of: "of {0}",
    Paginator_Label_Page: "Page",
    CellEditor_Label_UnknownName: "Unknown Name",
    CellEditor_Message_Input: "Input for cell in column '{0}'.",
    CellEditor_Message_MaxLength: "Max length {0} characters.",
    CellEditor_Validation_MaxLength: "{0}/{1}",
    CellEditor_Validation_Required: "Value is required",
    PagingTile_Label_NextItem: "Next {0}",
    PagingTile_Label_PageCount: "{0} of {1}",
    PagingTile_Label_PreviousItem: "Previous {0}",
    PagingTile_Message_GoToNextPage: "Go to next {0}",
    PagingTile_Message_GoToPreviousPage: "Go to previous {0}",
    PagingTile_Message_Item: "item",
    VisitorBannedMarker_Label_VisitorBanned: "Banned",
    VisitorHoldMarker_Label_VisitorHold: "Visitor Hold",
    SND_Action_BackToParent: "Back to parent",
    SND_Action_Clear: "Clear",
    SND_Action_Close: "Close",
    SND_Label_BackToParent: "Back to parent",
    SND_Label_Clear: "Clear",
    SND_Label_Close: "Close",
    SND_Label_Search: "Search",
    SND_Message_DefaultNoItems: "There are no items that match your search, please try again",
    SND_Message_DefaultNoSearchResults: "Cannot find any items that match your search",
    SND_Message_DefaultPlaceholder: "Please Select",
    SND_Message_DefaultSearchHelpMessage: "Please search for items",
    SND_Message_DefaultSearchPlaceholder: "Search",
    SND_Message_SearchResultsNotification: "Your search returned {0} results, press the down arrow to select the first item",
    UploadAvatar_Action_AcceptButton: "Crop Image",
    UploadAvatar_Action_TakePhoto: "Take Photo",
    UploadAvatar_Action_UploadPhoto: "Upload Photo",
    UploadAvatar_Action_UseCamera: "Use Camera",
    UploadAvatar_Label_AltText: "Uploaded File",
    UploadAvatar_Label_DragDrop1: "Drag and drop or",
    UploadAvatar_Label_DragDrop2: "upload from your computer",
    UploadAvatar_Label_DragToReposition: "Drag to reposition",
    UploadAvatar_Label_HeaderCaption: "Update Photo",
    UploadAvatar_Label_TakePhoto: "Take Photo",
    UploadAvatar_Label_UploadFile: "Upload File",
    UploadAvatar_Label_ZoomPhoto: "Zoom Photo",
    UploadAvatar_Message_ErrorMultipleFiles: "Please only drop a single file.",
    UploadAvatar_Message_InvalidFileType: "Only image file types are allowed",
    UploadAvatar_Message_NoCamera: "You do not seem to have a camera attached to this device, or the webpage does not have access to the camera, please use the Upload Photo tab to add a photo.",
    UploadAvatar_Message_UnableToUploadMessage: "Images must be in {0} format, and under {1}.",
    UploadAvatar_Message_UnableToUploadTitle: "Unable to upload this file.",
    UploadAvatar_Message_UnknownError: "An unknown error has occurred",
    Thumbnail_Action_Update: "Update",
    Searcher_Label_ClearSearch: "Clear Search",
    Searcher_Label_Search: "Search",
    EntryPicker_Label_Category: "Category",
    EntryPicker_Label_ClearSearch: "Clear Selected Entry",
    EntryPicker_Label_DOB: "DOB",
    EntryPicker_Label_EntryID: "Entry ID",
    EntryPicker_Label_FirstName: "First Name",
    EntryPicker_Label_LastName: "Last Name",
    EntryPicker_Label_PreferredName: "Preferred Name",
    EntryPicker_Label_RoomSpace: "Room Space",
    EntryPicker_Label_Status: "Status",
    EntryPicker_Message_InitialSearchInfo: "To search begin typing",
    EntryPicker_Message_NoResults: "Your search returned no results.",
    EntryPicker_Message_SearchPlaceholder: "Search for an Entry...",
    EntryPicker_Message_SelectedEntryInfo: "To search click the X button to first clear the selected Entry",
    DateTimePicker_Action_NextMonth: "Go to Next Month",
    DateTimePicker_Action_PreviousMonth: "Go to Previous Month",
    DateTimePicker_AriaLabel_CustomInput: "Custom Input",
    DateTimePicker_AriaLabel_CustomTimeInput: "Custom Time Input",
    DateTimePicker_Label_Calendar: "Calendar",
    DateTimePicker_Label_ClearDate: "Clear date",
    DateTimePicker_Label_DatePlaceholder: "DD-MM-YYYY",
    DateTimePicker_Label_DateTimePlaceholder: "DD-MM-YYYY  --:--",
    DateTimePicker_Label_DefaultDateFormat: "dd-MM-yyyy",
    DateTimePicker_Label_DefaultTimeFormat: "h:mm aa",
    DateTimePicker_Label_NextMonth: "Next Month",
    DateTimePicker_Label_PreviousMonth: "Previous Month",
    DateTimePicker_Message_SelectMonth: "Please select month",
    DateTimePicker_Message_SelectYear: "Please select year",
    ChartRangeDropDownPicker_Action_Apply: "Apply",
    ChartRangeDropDownPicker_Action_Cancel: "Cancel",
    ChartRangeDropDownPicker_AriaLabel_CompareFromWeek: "Compare from Week",
    ChartRangeDropDownPicker_AriaLabel_CompareToWeek: "Compare to Week",
    ChartRangeDropDownPicker_AriaLabel_SearchFromWeek: "Search from Week",
    ChartRangeDropDownPicker_AriaLabel_SearchToWeek: "Search to Week",
    ChartRangeDropDownPicker_Message_MultipleResultsFound: "{0} Results Found",
    ChartRangeDropDownPicker_Message_OneResultFound: "One Result Found",
    ChartRangeDropDownPicker_Message_SearchNoResultsFound: "No Results Found",
    ChartRangeDropDownPicker_Label_CompareToAnotherPeriod: "Compare to another period?",
    ChartRangeDropDownPicker_Label_From: "From",
    ChartRangeDropDownPicker_Label_To: "To",
    ChartRangeDropDownPicker_Label_Week: "Week",
    ChartRangeDropDownPicker_Label_WeekPlaceholder: "Please Select",
    ChartRangeDropDownPicker_Label_Year: "Year",
    ChartRangeDropDownPicker_Message_CompareFromWeek: "Compare From Week",
    ChartRangeDropDownPicker_Message_CompareFromYear: "Compare From Year",
    ChartRangeDropDownPicker_Message_CompareTo: "Compare To: {0}",
    ChartRangeDropDownPicker_Message_CompareToWeek: "Compare To Week",
    ChartRangeDropDownPicker_Message_CompareToYear: "Compare To Year",
    ChartRangeDropDownPicker_Message_CurrentFromWeek: "Current From Week",
    ChartRangeDropDownPicker_Message_CurrentFromYear: "Current From Year",
    ChartRangeDropDownPicker_Message_CurrentToWeek: "Current To Week",
    ChartRangeDropDownPicker_Message_CurrentToYear: "Current To Year",
    ChartRangeDropDownPicker_Message_NoItemsInWeekSearch: "No items available",
    ChartRangePicker_Label_Apply: "Apply",
    ChartRangePicker_Label_CompareTo: "Compare To:",
    ChartRangePicker_Label_From: "From",
    ChartRangePicker_Label_ReportDateRange: "Report Date Range",
    ChartRangePicker_Label_To: "To",
    ProgressTracker_Action_ViewNextStep: "Go to next step",
    ProgressTracker_Action_ViewPreviousStep: "Go to previous step",
    ProgressTracker_Label_CurrentStep: "Step {0}/{1}",
    // Flags:
    Label_Flags: "Flags",
    // tslint:disable-next-line: object-literal-sort-keys
    Flags_Label_AccountHold: "Account Hold",
    Flags_Label_IncidentHold: "Incident Hold",
    Flags_Label_MedicalHold: "Medical Hold",
    Flags_Label_Privacy: "Privacy",
    Flags_Label_SituationResponseNotOkay: "Not Okay",
    Flags_Label_SituationResponseOkay: "Okay",
    Flags_Label_SituationResponseTooltip: "Situation Response: {0}",
    Flags_Label_VisitorHold: "Visitor Hold",
    Label_Jan: "January",
    // tslint:disable-next-line: object-literal-sort-keys
    Label_Feb: "February",
    Label_Mar: "March",
    Label_Apr: "April",
    Label_May: "May",
    Label_Jun: "June",
    Label_Jul: "July",
    Label_Aug: "August",
    Label_Sep: "September",
    Label_Oct: "October",
    Label_Nov: "November",
    Label_Dec: "December",
    FilterBar_Label_AddFilter: "Add Filter",
    FilterBar_Label_EditFilter: "Edit Filter",
    FilterBar_Label_RemoveFilter: "Remove Filter",
    FilterBar_Label_IsMissing: "{0} is missing a value",
    FilterBar_Label_Is: "is",
    FilterBar_Label_PlusMore: "+ More",
    FilterBar_Label_NotProvided: "(Not Provided)",
    // Searchable Tree View
    SearchableTreeview_Action_ClearThisSearch: "Clear this Search",
    SearchableTreeview_Action_Search: "Search",
    SearchableTreeview_Action_DeselectAll: "Deselect All",
    SearchableTreeview_Action_SelectAll: "Select All",
    SearchableTreeview_Label_ItemsSelected: "{0} Items selected",
    CollapsibleContainer_Label_ButtonTitle: "Collapse Container",
    CollapsibleContainer_Label_ButtonAriaLabel: "Collapse Container",
    // Concealed Field Viewer
    ConcealedFieldViewer_Title_View: "This field is concealed.\nClick to reveal.",
    ConcealedFieldViewer_Title_Conceal: "Click to conceal this field.",
};
exports.strings = new react_localization_1.default({
    "en": __assign({}, english),
    "en-US": __assign(__assign({}, english), { FieldSelector_Label_MyFavourites: "My Favorites", FieldSelector_Action_AddToFavs: "Add to favorites", FieldSelector_Action_RemoveFromFavs: "Remove from favorites", DateTimePicker_Label_DatePlaceholder: "MM-DD-YYYY", DateTimePicker_Label_DateTimePlaceholder: "MM-DD-YYYY  --:-- --", DateTimePicker_Label_DefaultDateFormat: "MM-dd-yyyy", DateTimePicker_Label_DefaultTimeFormat: "h:mm aa" }),
});
